import { JourneyInteraction } from '../../../models/journey-explorer/journey-explorer';

export interface StepRow {
	name: string;
	customers: number;
	customersPct: number;
	interactions: number;
	perCustomer: number;
	reachedPct: number;
	exitPct: number;
	medianSecs: number | null;
}

export type StepSortKey = 'name' | 'customers' | 'perCustomer' | 'reachedPct' | 'exitPct' | 'medianSecs';

export interface StepSort {
	key: StepSortKey;
	descending: boolean;
}

export const DEFAULT_STEP_SORT: StepSort = { key: 'customers', descending: true };

const share = (part: number, whole: number) => (whole > 0 ? (part / whole) * 100 : 0);

export const buildStepRows = (interactions: JourneyInteraction[], totalCustomers: number): StepRow[] =>
	interactions.map((item) => ({
		name: item.name,
		customers: item.customers,
		customersPct: share(item.customers, totalCustomers),
		interactions: item.interactions,
		perCustomer: item.customers > 0 ? item.interactions / item.customers : 0,
		reachedPct: item.reached_pct,
		exitPct: share(item.exits, item.customers),
		medianSecs: item.median_secs_to_next,
	}));

// Steps without a time always sort last, whichever way the column is sorted.
export const sortSteps = (rows: StepRow[], { key, descending }: StepSort, label: (name: string) => string): StepRow[] =>
	[...rows].sort((a, b) => {
		if (key === 'name') {
			const order = label(a.name).localeCompare(label(b.name));
			return descending ? -order : order;
		}
		const left = a[key];
		const right = b[key];
		if (left === null || right === null) {
			return left === right ? 0 : left === null ? 1 : -1;
		}
		return (descending ? right - left : left - right) || b.customers - a.customers;
	});

export const toggleStepSort = (current: StepSort, key: StepSortKey): StepSort =>
	current.key === key ? { key, descending: !current.descending } : { key, descending: key !== 'name' };

export const matchesStep = (label: string, query: string): boolean =>
	label.toLowerCase().includes(query.trim().toLowerCase());
